const indexItems = [
  {
    title: '久久视频资源专区',
    desc: '久久视频在线视频网站全部资源入口与热门内容推荐，视频播放器在线看视频首选站点。',
    count: '1280+ 资源',
    icon: 'ri-movie-line',
  },
  {
    title: '芒果视频导航中心',
    desc: '芒果视频在线视频网站资源导航中心，涵盖视频播放器在线看视频的全部优质内容。',
    count: '960+ 资源',
    icon: 'ri-film-line',
  },
  {
    title: '97视频入口合集',
    desc: '97视频平台多渠道访问入口汇总，保障视频播放器在线看视频的连续稳定使用体验。',
    count: '850+ 资源',
    icon: 'ri-play-circle-line',
  },
  {
    title: '丝瓜视频资源汇总',
    desc: '丝瓜视频在线视频网站精品资源汇总专区，为您整理视频播放器在线看视频优质内容。',
    count: '720+ 资源',
    icon: 'ri-clapperboard-line',
  },
  {
    title: '蓝莓视频最新入口',
    desc: '蓝莓视频在线视频网站最新可用访问入口，持续更新视频播放器在线看视频站点链接。',
    count: '650+ 资源',
    icon: 'ri-live-line',
  },
  {
    title: '91在线视频专区',
    desc: '91在线视频平台资源专区，提供经典在线视频网站的视频播放器在线看视频完整导航。',
    count: '580+ 资源',
    icon: 'ri-tv-line',
  },
  {
    title: '视频播放器工具集',
    desc: '视频播放器在线看视频实用工具与技巧合集，提升在线视频网站浏览与播放整体体验。',
    count: '420+ 工具',
    icon: 'ri-tools-line',
  },
  {
    title: '在线视频网站大全',
    desc: '国产91视频完整在线视频网站收录列表，久久视频、芒果视频等热门站点一应俱全。',
    count: '200+ 站点',
    icon: 'ri-global-line',
  },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">
          主题索引
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-12 max-w-lg mx-auto">
          国产91视频完整主题索引，久久视频、芒果视频、97视频等在线视频网站资源分类浏览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {indexItems.map((item, i) => (
            <div
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/70 p-6 hover:border-primary-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mb-4 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm font-bold text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
              <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-2.5 py-1 rounded-md whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}